<template>
  <div>
    <v-btn x-small color="warning" @click="openDialog" icon>
      <v-icon small>mdi-pencil</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <ModalHeader
          :title="'Edit Payment #' + payment.id"
          icon="mdi-cash-edit"
          @close="dialog = false"
        />
        <v-card-text class="pa-4">
          <v-form ref="form">
            <v-text-field
              outlined
              dense
              label="Amount Paid"
              v-model="form.amount_paid"
              type="number"
            ></v-text-field>
            <v-select
              outlined
              dense
              :items="chart_of_accounts"
              item-text="account_title"
              item-value="id"
              label="Payment Method"
              v-model="form.chart_of_account_id"
            ></v-select>
            <p class="caption mb-1">Payment Date</p>
            <input type="date" v-model="form.payment_date" class="mb-3" />
            <v-text-field
              outlined
              dense
              label="OR Number"
              v-model="form.or_number"
            ></v-text-field>
            <v-select
              outlined
              dense
              :items="['Tax Exempt', 'VAT', 'Non-Vat']"
              label="Tax Code"
              v-model="form.tax_code"
            ></v-select>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="edit" color="primary" :loading="loading">Save</v-btn>
          <v-btn @click="dialog = false" text>Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["payment", "invoice"],
  data() {
    return {
      dialog: false,
      loading: false,
      form: {
        id: null,
        invoice_id: null,
        amount_paid: 0,
        chart_of_account_id: null,
        payment_date: "",
        or_number: 0,
        tax_code: "Tax Exempt",
        invoice_status: "",
        balance: 0,
        total_payable_amount: 0,
      },
    };
  },
  computed: {
    ...mapGetters({
      chart_of_accounts: "chart_of_account/chart_of_accounts",
    }),
  },
  methods: {
    ...mapActions({
      edit_payment: "payment/edit_payment",
      get_chart_of_accounts: "chart_of_account/get_chart_of_accounts",
    }),
    openDialog() {
      this.form.id = this.payment.id;
      this.form.invoice_id = this.payment.invoice_id;
      this.form.amount_paid = this.payment.amount_paid;
      this.form.chart_of_account_id = this.payment.chart_of_account_id;
      this.form.payment_date = this.payment.payment_date;
      this.form.or_number = this.payment.or_number;
      this.form.tax_code = this.payment.tax_code;
      if (this.chart_of_accounts.length <= 0) {
        this.get_chart_of_accounts();
      }
      this.dialog = true;
    },
    async edit() {
      let x = await this.$confirm({
        title: "Edit Payment",
        message: "Are you sure you want to edit this payment?",
        color: "primary",
        icon: "mdi-pencil",
      });
      if (!x) return;

      this.loading = true;
      // Recalculate balance: sum all other payments + this edited one
      const otherPaymentsTotal = this.invoice.payments
        .filter((p) => p.id !== this.payment.id)
        .reduce((sum, p) => sum + Number(p.amount_paid), 0);
      const newTotal = otherPaymentsTotal + Number(this.form.amount_paid);
      const invoiceTotal = Number(this.invoice.total_amount);
      this.form.balance = invoiceTotal - newTotal;
      this.form.total_payable_amount = invoiceTotal;
      this.form.invoice_status =
        this.form.balance <= 0 ? "Paid" : "With Balance";

      try {
        const updatedInvoice = await this.edit_payment(this.form);
        // Update the invoice object in-place so the parent UI reflects changes
        if (updatedInvoice) {
          this.invoice.payments = updatedInvoice.payments;
          this.invoice.balance = updatedInvoice.balance;
          this.invoice.invoice_status = updatedInvoice.invoice_status;
        }
        this.$alert({
          title: "Success",
          message: "Payment updated successfully!",
          color: "success",
          icon: "mdi-check-circle",
        });
        this.dialog = false;
      } catch (e) {
        this.$alert({
          title: "Error",
          message: String(e.response ? e.response.data : e.message),
          color: "error",
          icon: "mdi-alert-circle",
        });
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
